var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 16,
    r: 14.8821,
    stroke: "white",
    strokeWidth: 1.06301
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7793 20.8696V11.1305C11.7793 10.7093 12.2459 10.4554 12.5995 10.6842L20.1252 15.5538C20.4489 15.7633 20.4489 16.2368 20.1252 16.4463L12.5995 21.3158C12.2459 21.5447 11.7793 21.2908 11.7793 20.8696Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.06301
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/play-button.8b7aa746182020732d8906d8fb5243ac.svg";
export { ForwardRef as ReactComponent };